<section
  class="section-basic"
  [class.pai-richtext__centered]="data().alignment === 'center'"
  [style.--padding-top.px]="design().padding.top"
  [style.--padding-bottom.px]="design().padding.bottom"
>
  <div class="section-content-center__content">
    @for (item of data().content; track item.id) {
      <ng-template [paiInsertDynamicContent]="item" />
    }
  </div>
</section>
